<template>
    <div class="rb">
        <div ref="Rmain" class="Rmain"></div>
    </div>
</template>

<script>
import * as methods from './method.js'
import * as echarts from 'echarts';
import 'echarts-wordcloud';
export default {
    name: 'template.scope78',
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            title: 'scope6-【组件】词云样式2-完成',
            timer: null,
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
            ],
            defaultdata: [
                { value1: '文本一', value2: 366 },
                { value1: "文本二", value2: 800 },
                { value1: "文本三", value2: 606 },
                { value1: "文本四", value2: 1000 },
                { value1: "文本五", value2: 535 },
                { value1: "文本六", value2: 535 },
                { value1: "文本七", value2: 535 },
                { value1: "文本八", value2: 400 },
                { value1: "文本九", value2: 535 },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {}
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n
                this.TdrawLine()
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.initEcharts()
        }
    },
    methods: {
        ...methods,
        initEcharts() {
            clearInterval(this.timer);
            this.timer = null

            var TmyChart = echarts.init(this.$refs.Rmain);
            let data = this.defaultdata.map(item => {
                let name = item.value1;
                if (name.length > 10) {
                    name = name.slice(0, 10) + '...';
                }
                return {
                    name: name,
                    value: +item.value2,
                    name1: item.value1    //请勿删除，用于显示tooltip
                };
            });
            // console.log(data,"|scope6|");

            var colorList = ["#d09426", "#0191cd", "#3bc1c2", "#01b7ff", "#a5a2f9"];
            let Toption = {
                tooltip: {
                    // 显示tooltip
                    show: true,
                    // 格式化tooltip内容
                    formatter: function (params) {
                        // return  params.name + '<br>' + params.value;

                        return params.data.name1;
                    }
                },
                series: [
                    {
                        type: "wordCloud", //用来调整词之间的距离
                        gridSize: 10, //用来调整字的大小范围
                        sizeRange: [12, 22],
                        rotationRange: [0, 0], //随机生成字体颜色
                        textStyle: {
                            color: function () {
                                return colorList[Math.floor(Math.random() * 5)];
                                //colorList[1]
                            },
                            normal: {
                                color: function () {
                                    return colorList[2];
                                }
                            }
                        }, //位置相关设置
                        left: "center",
                        top: "center",
                        right: null,
                        bottom: null,
                        width: "300%",
                        height: "150%", //数据
                        data: data
                    }
                ]
            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata
        }
        this.setData()
        this.$nextTick(() => {
            this.initEcharts()
        });
    },
}
</script>

<style scoped>
.rb {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;
}

.Rmain {
    width: 435px;
    height: 240px;
    background: url('../../assets/temimg2/dz.png') no-repeat;
    background-size: 100% 100%;
    background-position: 0 10px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}

.cy_cen {
    width: 350px;
    height: 180px;
    margin-left: 60px;
    margin-top: -30px;
    background: url('../../assets/temimg2/dz.png') no-repeat;
    background-size: 100% 100%;
    background-position: 0 10px;
    display: inline-block;
}
</style>